@if(dataLoaded()) {
  <schedule-detail-header [title]="title()"
                          [subtitle]="subtitle()"
                          [backCallback]="onBack.bind(this)"
                          [backLabel]="(backLabel())"
                          [showCloud]="true"
                          [isRefreshingInBackground]="isRefreshingInBackground()" />
  <p-tabs [value]="tab()"
          (valueChange)="onTabChange($event)"
          class="tab-container"
          [appDataUpdatedFade]="dataUpdatedPulse()"
          data-testid="job-areas-tabs">
    <p-tablist [class.faded]="isEditing()">
      <p-tab [value]="JobOverviewTabsEnum.Locations"
             data-testid="job-areas-tab-locations">
        Locations
      </p-tab>
      <p-tab [value]="JobOverviewTabsEnum.NeedsAttention"
             data-testid="job-areas-tab-needs-attention">
        Needs Attention
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <div class="search-btn-overlay">
        <p-tabpanel [value]="JobOverviewTabsEnum.Locations">
          <locations-tab [areasWithDetails]="areasWithDetails()"
                         [bqStep]="bqStep()"
                         (isEditingChange)="isEditing.set($event)" />
        </p-tabpanel>
        <p-tabpanel [value]="JobOverviewTabsEnum.NeedsAttention">
          <needs-attention-tab [bqStep]="bqStep()" />
        </p-tabpanel>
        <div class="search-btn-container">
          @if (!isEditing() && !searchVisible() && !bottomSheetState.hasOpenSheet()) {
            <p-button type="button"
                      icon="pi pi-search"
                      styleClass="job-areas-search-fab"
                      [rounded]="true"
                      (onClick)="onOpenSearch()"
                      ariaLabel="Search inspection items"
                      data-testid="job-areas-btn-open-search" />
          }
        </div>
        @if (searchVisible()) {
          <app-inspection-item-search [items]="searchableInspectionItems()"
                                      (closeSearch)="onCloseSearch()"
                                      (selectSearchResult)="onNavigateToSearchResult($event)" />
        }
      </div>
    </p-tabpanels>
  </p-tabs>
  @if (!isEditing()) {
    <app-job-detail-footer [buttonText]="'Final Review'"
                           [completedItems]="completedAreaCount()"
                           [totalItems]="totalAreaCount()"
                           (buttonClickCallBack)="onFinalReviewClick()" />
  }
}